import http from "../http-common";
import authHeader from "./authHeader";
import { EMPLOYEE_API } from "../api";

const login = (data) => {
  return http.post(`${EMPLOYEE_API}/login`, data);
};
const logout = () => {
  localStorage.removeItem("user");
};

const AuthService = {
  login,
  logout,
};

export default AuthService;
